<template>
  <div id="invoice-accounts-receivable">
    <BreadCrumb :items="breadcrumbItems" />
    <v-card elevation="1" class="pa-2">
      <v-card-title class="header d-flex justify-space-between align-center">
        <h1 class="pa-0">Faturamento</h1>
        <div>
          <v-btn @click="handleExport" :loading="isExportButtonLoading" elevation="2" color="info" large>
            Exportar planilha
          </v-btn>
        </div>
      </v-card-title>

      <v-expansion-panels accordion class="mt-2 mb-10 px-4">
        <v-expansion-panel class="elevation-1">
          <v-expansion-panel-header color="#f2f2f2" class="px-4">
            <span>Filtrar por</span>
            <template v-slot:actions>
              <v-icon color="black"> mdi-chevron-down </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="mt-2 pb-1">
              <v-col cols="12" md="4" class="pb-0">
                <h5>Data de Criação</h5>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="4" class="pb-0">
                <h5>Data de Previsão</h5>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="4" class="pb-0">
                <h5>Data de Recebimento</h5>
              </v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu v-model="initialCreatedAtMenu" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedInitialCreatedAt"
                      label="Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="initialCreatedAt" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu v-model="endCreatedAtMenu" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedEndCreatedAt"
                      label="Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endCreatedAt" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu v-model="initialForecastMenu" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedInitialForecast"
                      label="Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="initialForecast" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu v-model="endForecastMenu" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedEndForecast"
                      label="Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endForecast" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu v-model="initialPaymentMenu" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedInitialPayment"
                      label="Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="initialPayment" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu
                  v-model="endPaymentMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedEndPayment"
                      label="Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endPayment" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="shipperId"
                  :items="senders"
                  item-text="name"
                  item-value="id"
                  label="Embarcador"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="statusId"
                  :items="getSummaryStatus"
                  label="Status do Pagamento"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field v-model="invoiceId" label="Id da Fatura"></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-combobox
                  v-model="boardingNumbers"
                  :search-input.sync="boardingNumbersInput"
                  append-icon=""
                  label="Embarque externo"
                  hide-selected
                  multiple
                  chips
                  deletable-chips
                  @keydown.native="filterInput"
                  @change="saveBoardingNumbers"
                ></v-combobox>
              </v-col>

              <v-col cols="12" md="4">
                <v-combobox
                  v-model="numbersCtes"
                  :search-input.sync="numbersCtesInput"
                  append-icon=""
                  label="Número CTE"
                  hide-selected
                  multiple
                  chips
                  deletable-chips
                  @keydown.native="filterInput"
                  @change="saveCteNumber"
                ></v-combobox>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field v-model="externalInvoiceNumber" label="Id da Fatura Externa"></v-text-field>
              </v-col>

              <v-col cols="12" md="12" class="d-flex justify-end align-center">
                <v-btn @click="cleanFilter()" :disabled="!hasFilters" elevation="2" color="red" class="mx-2 text-white">
                  Limpar Filtros
                </v-btn>
                <v-btn
                  :loading="isLoading"
                  elevation="2"
                  color="green"
                  class="text-white"
                  :disabled="!hasFilters"
                  @click="search()"
                >
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card-text v-if="isItemMenuLoading" class="d-flex justify-center py-12">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-card-text>

      <v-data-table
        v-else
        class="mt30 px-5"
        :headers="columnOptions"
        :items="invoices"
        :items-per-page="pageSize"
        :loading="isLoading"
        @update:items-per-page="changeItemsPerPage"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 50],
          itemsPerPageText: 'Itens por página'
        }"
        no-data-text="Nenhum resultado encontrado"
      >
        <template #[`item.receiptForecast`]="{ item }">
          <span> {{ transformDate(item.receiptForecast) }}</span>
        </template>
        <template #[`item.paymentReceived`]="{ item }">
          <span v-if="item.paymentReceived"> {{ transformDate(item.paymentReceived) }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:[`item.approval`]="{ item }">
          <span v-if="item.approval !== null"> {{ getApproval(item.approval) }}</span>
          <span v-else>-</span>
        </template>
        <template #[`item.totalValue`]="{ item }">
          <span>{{ formatMoney(item.totalValue) }}</span>
        </template>
        <template #[`item.actions`]="{ item }">
          <div class="d-flex">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  style="font-size: 24px; position: relative; top: -6px"
                  color="black"
                  dense
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-menu
                </v-icon>
              </template>
              <v-list v-if="item.paymentReceived">
                <v-list-item
                  v-for="(itemDrop, indexDropdown) in itemsDropdown2"
                  :key="indexDropdown"
                  @click="actionsDropdown2(item, indexDropdown)"
                >
                  <v-list-item-title>{{ itemDrop.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
              <v-list v-else>
                <v-list-item
                  v-for="(itemDrop, indexDropdown) in itemsDropdown"
                  :key="indexDropdown"
                  @click="actionsDropdown(item, indexDropdown)"
                >
                  <v-list-item-title>{{ itemDrop.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <v-pagination v-model="pageNumber" :length="totalPages" :total-visible="7"></v-pagination>
    </v-card>
    <invoice-edit-form
      :isOpen.sync="isEditionDialogOpen"
      :invoiceToEdit="invoiceToEdit"
      @shouldUpdateList="fetchAllInvoices"
    />
    <delete-confirm-dialog
      :isOpen.sync="isDeleteDialogOpen"
      :isConfirmBtnLoading="isDeleteButtonLoading"
      @confirmClick="deleteInvoice()"
      title="Desfazer fatura"
      body-text="Você confirma estar desfazendo esta fatura?"
    />
    <invoice-details-dialog
      :isOpen.sync="isDetailsDialogOpen"
      :invoiceId="idInvoiceDetail"
      @edit-invoice="handleEdit"
      @delete-invoice="handleDelete"
    />
    <send-email-invoice :isOpen.sync="isSendEmailDialogOpen" :invoiceId="invoiceIdItem" />
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';
import { mapActions } from 'vuex';
import maskData from '../../../utils/maskData';
import maskPrice from '../../../utils/maskPrice';
import InvoiceEditForm from '@/components/AccountsReceivable/InvoiceEditForm.vue';
import InvoiceDetailsDialog from '@/components/AccountsReceivable/InvoiceDetailsDialog.vue';
import SendEmailInvoice from '@/components/AccountsReceivable/SendEmailInvoice.vue';
import DeleteConfirmDialog from '@/components/ConfirmDialog';
import MessagesError from '@/components/MessagesError.vue';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';
import comboboxFormatter from '@/utils/comboboxFormatter';
import allowedChars from '@/utils/allowedChars';

export default {
  name: 'InvoicesAccountsReceivable',
  components: {
    BreadCrumb,
    InvoiceEditForm,
    DeleteConfirmDialog,
    InvoiceDetailsDialog,
    MessagesError,
    SendEmailInvoice
  },
  data: () => ({
    isExportButtonLoading: false,
    isEditionDialogOpen: false,
    detailsDialog: false,
    isDeleteDialogOpen: false,
    isDeleteButtonLoading: false,
    isDetailsDialogOpen: false,
    isSendEmailDialogOpen: false,
    isItemMenuLoading: false,
    isLoading: true,
    shipperId: null,
    initialCreatedAt: null,
    initialCreatedAtMenu: false,
    endCreatedAt: null,
    endCreatedAtMenu: false,
    initialForecast: null,
    initialForecastMenu: false,
    endForecast: null,
    endForecastMenu: false,
    initialPayment: null,
    initialPaymentMenu: false,
    endPayment: null,
    endPaymentMenu: false,
    statusId: null,
    boardingNumbersInput: '',
    boardingNumbers: [],
    invoiceId: null,
    externalInvoiceNumber: null,
    numbersCtesInput: '',
    numbersCtes: [],
    selectedItem: null,
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Financeiro',
        disabled: true
      },
      {
        text: 'Contas a receber',
        disabled: true
      },
      {
        text: 'Faturas',
        disabled: true
      }
    ],
    columnOptions: [
      {
        value: 'numberInvoiceId',
        text: 'ID FATURA',
        sortable: false
      },
      {
        value: 'senderNome',
        text: 'NOME DO EMBARCADOR',
        sortable: false
      },
      {
        value: 'externalInvoiceNumber',
        text: 'ID FATURA EXTERNA',
        sortable: false
      },
      {
        value: 'receiptForecast',
        text: 'PREVISÃO DE RECEBIMENTO',
        sortable: false
      },
      {
        value: 'paymentReceived',
        text: 'PAGAMENTO REALIZADO',
        sortable: false
      },
      {
        value: 'statusName',
        text: 'STATUS',
        sortable: false
      },
      {
        value: 'approval',
        text: 'APROVAÇÃO',
        sortable: false
      },
      {
        value: 'totalValue',
        text: 'VALOR TOTAL',
        sortable: false
      },
      {
        value: 'actions',
        text: 'AÇÕES',
        sortable: false
      }
    ],
    pageNumber: 1,
    pageSize: 10,
    totalPages: 0,
    itemsDropdown: [
      { title: 'Editar' },
      { title: 'Ver detalhes' },
      { title: 'Imprimir Fatura' },
      { title: 'Baixar Canhotos Imagens' },
      { title: 'Baixar Canhotos PDF' },
      { title: 'Baixar XMLs' },
      { title: 'Envios de Email' },
      { title: 'Desfazer' }
    ],
    itemsDropdown2: [
      { title: 'Editar' },
      { title: 'Ver detalhes' },
      { title: 'Imprimir Fatura' },
      { title: 'Baixar Canhotos Imagens' },
      { title: 'Baixar Canhotos PDF' },
      { title: 'Baixar XML' },
      { title: 'Envios de Email' }
    ],
    invoices: [],
    senders: [],
    invoiceIdItem: null,
    getSummaryStatus: [],
    invoiceToEdit: {
      id: null,
      receiptNumber: null,
      externalInvoiceNumber: null,
      invoiceDate: null,
      receiptForecast: null,
      paymentReceived: null,
      observation: null
    },
    idInvoiceDetail: null,
    errors: [],
    errorsType: 'error',
    error500: null
  }),

  computed: {
    formattedInitialCreatedAt() {
      let date = this.initialCreatedAt;
      return this.formatDate(date);
    },

    formattedEndCreatedAt() {
      let date = this.endCreatedAt;
      return this.formatDate(date);
    },

    formattedInitialForecast() {
      let date = this.initialForecast;
      return this.formatDate(date);
    },

    formattedEndForecast() {
      let date = this.endForecast;
      return this.formatDate(date);
    },

    formattedInitialPayment() {
      let date = this.initialPayment;
      return this.formatDate(date);
    },

    formattedEndPayment() {
      let date = this.endPayment;
      return this.formatDate(date);
    },

    hasFilters() {
      return (
        this.invoiceId ||
        this.initialCreatedAt !== null ||
        this.endCreatedAt !== null ||
        this.initialForecast !== null ||
        this.endForecast !== null ||
        this.initialPayment !== null ||
        this.endPayment !== null ||
        this.shipperId !== null ||
        this.statusId !== null ||
        this.externalInvoiceNumber ||
        this.boardingNumbers.length ||
        this.numbersCtes.length
      );
    },

    getTheLastThirtyDays() {
      const now = new Date();
      const currentDay = now;
      const thirtyDayAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);

      return {
        thirtyDayAgo: thirtyDayAgo.toISOString().slice(0, 10),
        currentDay: currentDay.toISOString().slice(0, 10)
      };
    }
  },

  watch: {
    pageNumber: {
      handler() {
        this.fetchAllInvoices();
      }
    }
  },

  created() {
    this.filterTheLastThirtyDays();
    this.fetchAllInvoices();
    this.getAllSenders();
    this.getInvoiceStatus();
  },

  methods: {
    ...mapActions('AccountsReceivableStore', ['getSenders']),
    ...mapActions('ShippersStore', ['downloadReceiptsByInvoice', 'downloadReceiptPdfByInvoice']),
    ...mapActions('InvoicesReceivableStore', [
      'getInvoicesReceivable',
      'fetchInvoiceStatus',
      'undoInvoiceReceivable',
      'exportInvoiceSheet',
      'exportPdfInvoice'
    ]),
    ...mapActions('ImportXmlStore', ['downloadCteXmlsByInvoice']),

    async fetchAllInvoices() {
      this.isLoading = true;
      try {
        const filters = this.getFilters();
        const { data, totalPages, totalRecords } = await this.getInvoicesReceivable({ ...filters });
        this.totalPages = totalPages;
        this.totalRecords = totalRecords;
        this.invoices = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },

    filterTheLastThirtyDays() {
      const { thirtyDayAgo, currentDay } = this.getTheLastThirtyDays;
      this.initialCreatedAt = thirtyDayAgo;
      this.endCreatedAt = currentDay;
    },

    async deleteInvoice() {
      try {
        this.isDeleteButtonLoading = true;

        const data = await this.undoInvoiceReceivable(this.invoiceIdItem);
        if (data.success) {
          this.handleSuccessFeedbackToDelete();
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (e) {
        console.error(e);
        this.errors = ['Opss, algo deu errado!'];
        this.errorsType = 'error';
      } finally {
        this.isDeleteButtonLoading = false;
        this.setClearErrorTimer();
      }
    },

    async handleExport() {
      try {
        this.isExportButtonLoading = true;

        const filters = this.getFilters();
        const data = await this.exportInvoiceSheet({ ...filters, pageSize: this.totalRecords });
        if (data.success) {
          this.errors = ['Planilha exportada com sucesso!'];
          this.errorsType = 'success';
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isExportButtonLoading = false;
        this.setClearErrorTimer();
      }
    },

    async getAllSenders() {
      try {
        this.senders = await this.getSenders();
      } catch (error) {
        console.error(error);
      }
    },

    async getInvoiceStatus() {
      try {
        const summaryStatus = await this.fetchInvoiceStatus();
        this.getSummaryStatus = summaryStatus;
      } catch (error) {
        console.error(error);
      }
    },

    async getPDF() {
      try {
        this.isItemMenuLoading = true;
        const data = await this.exportPdfInvoice(this.invoiceIdItem);
        if (data.success) {
          this.errors = ['Pdf exportado com sucesso!'];
          this.errorsType = 'success';
        } else {
          this.errors = data.errors || ['Erro ao imprimir fatura'];
          this.errorsType = 'error';
        }
      } catch (e) {
        this.errors = e;
        this.errorsType = 'error';
      } finally {
        this.setClearErrorTimer();
        this.isItemMenuLoading = false;
      }
    },

    async exportReceiptsImage() {
      try {
        this.isItemMenuLoading = true;
        const data = await this.downloadReceiptsByInvoice(this.invoiceIdItem);
        if (data.success) {
          FeedbackMessageHandler.setFeedbackMessage(this, 'Exportação criada com sucesso!');
          this.$router.push('/receipts-export-image');
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isItemMenuLoading = false;
      }
    },

    async exportReceiptsPdf() {
      try {
        this.isItemMenuLoading = true;
        const data = await this.downloadReceiptPdfByInvoice(this.invoiceIdItem);
        if (data.success) {
          FeedbackMessageHandler.setFeedbackMessage(this, 'Exportação criada com sucesso!');
          this.$router.push('/receipts-export-pdf');
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isItemMenuLoading = false;
      }
    },

    async exportCtesXmls() {
      try {
        this.isItemMenuLoading = true;
        const data = await this.downloadCteXmlsByInvoice(this.invoiceIdItem);
        if (data.success) {
          FeedbackMessageHandler.setFeedbackMessage(this, 'Exportação dos XMLs criado com sucesso!');
          this.$router.push('/xmls-ctes-export');
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isItemMenuLoading = false;
      }
    },

    changeItemsPerPage(items) {
      this.pageSize = items;
      this.pageNumber = 1;
      this.fetchAllInvoices();
    },

    actionsDropdown(item, index) {
      this.invoiceIdItem = item.id;
      if (index == 0) {
        this.openInvoiceEdit(item);
      }
      if (index == 1) {
        this.openInvoiceDetails(item);
      }
      if (index == 2) {
        this.getPDF();
      }
      if (index == 3) {
        this.exportReceiptsImage();
      }
      if (index == 4) {
        this.exportReceiptsPdf();
      }
      if (index == 5) {
        this.exportCtesXmls();
      }
      if (index == 6) {
        this.isSendEmailDialogOpen = true;
      }
      if (index == 7) {
        this.isDeleteDialogOpen = true;
      }
    },

    actionsDropdown2(item, index) {
      this.invoiceIdItem = item.id;
      if (index == 0) {
        this.openInvoiceEdit(item);
      }
      if (index == 1) {
        this.openInvoiceDetails(item);
      }
      if (index == 2) {
        this.getPDF();
      }
      if (index == 3) {
        this.exportReceiptsImage();
      }
      if (index == 4) {
        this.exportReceiptsPdf();
      }
      if (index == 5) {
        this.exportCtesXmls();
      }
      if (index == 6) {
        this.isSendEmailDialogOpen = true;
      }
    },

    handleEdit(invoiceDetails) {
      this.openInvoiceEdit(invoiceDetails);
    },

    handleDelete(idInvoice) {
      this.invoiceIdItem = idInvoice;
      this.isDeleteDialogOpen = true;
    },

    openInvoiceEdit(item) {
      this.invoiceToEdit = {
        id: item.id,
        receiptNumber: item.receiptNumber,
        externalInvoiceNumber: item.externalInvoiceNumber,
        invoiceDate: item.invoiceDate,
        receiptForecast: item.receiptForecast,
        paymentReceived: item.paymentReceived,
        observation: item.observation
      };
      this.isEditionDialogOpen = true;
    },

    openInvoiceDetails(item) {
      this.idInvoiceDetail = item.id;
      this.isDetailsDialogOpen = true;
    },

    handleSuccessFeedbackToDelete() {
      this.errors = ['Fatura desfeita com sucesso!'];
      this.errorsType = 'success';
      this.isDeleteDialogOpen = false;
      this.setClearErrorTimer();
      this.fetchAllInvoices();
    },

    getApproval(approval) {
      return approval ? 'Aprovado' : 'Rejeitado';
    },

    transformDate(date) {
      return maskData(date);
    },

    transformPrice(price) {
      return maskPrice(price);
    },

    formatMoney(money) {
      return money.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL'
      });
    },

    formatDate(d) {
      if (d === null) return d;
      let dateObj = new Date(`${d}T00:00:00`);
      return dateObj.toLocaleDateString('pt-BR');
    },

    search() {
      this.pageNumber = 1;
      this.fetchAllInvoices();
    },

    filterInput(event) {
      return allowedChars(event, /[0-9,.;/]/);
    },

    saveBoardingNumbers(value) {
      this.boardingNumbers = comboboxFormatter(value);
    },

    saveCteNumber(value) {
      this.numbersCtes = comboboxFormatter(value);
    },

    setClearErrorTimer() {
      setTimeout(() => {
        this.errors = [];
      }, 6000);
    },

    getFilters() {
      return {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        createdAtStart: this.initialCreatedAt,
        createdAtEnd: this.endCreatedAt,
        receiptForecastStart: this.initialForecast,
        receiptForecastEnd: this.endForecast,
        paymentReceivedStart: this.initialPayment,
        paymentReceivedEnd: this.endPayment,
        senderId: this.shipperId,
        statusId: this.statusId,
        numberInvoiceId: this.invoiceId,
        externalInvoiceNumber: this.externalInvoiceNumber,
        boardingNumbers: this.boardingNumbers,
        cteNumbers: this.numbersCtes
      };
    },

    cleanFilter() {
      this.invoiceId = null;
      this.initialCreatedAt = null;
      this.endCreatedAt = null;
      this.initialForecast = null;
      this.endForecast = null;
      this.initialPayment = null;
      this.endPayment = null;
      this.shipperId = null;
      this.statusId = null;
      this.externalInvoiceNumber = null;
      this.boardingNumbers = [];
      this.numbersCtes = [];

      this.fetchAllInvoices();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}

::v-deep .v-data-table-header tr th {
  background-color: #e0e0e0 !important;
  border: 1px solid #e0e0e0;
}
</style>
